import {Component} from 'react';
import h from 'react-hyperscript';
import './Hero.scss';
import Image from 'Components/Image/Image';
import {h3, p} from 'Components/Typography/Typography';

class Hero extends Component {
  render() {
    const {
      title,
      subtitle,
      paragraphTwo,
      sectionOne,
    } = this.props.content;
    return (
      h('div', {
        className: 'report-overview__hero flex flex--align-end',
      }, [
        h('div', {
          key: 'hero__text',
          className: 'col-ratio-1',
        }, [
          title &&
            h(h3, {
              key: 'hero__title',
              className: 'hero__title padding-bottom--sm',
            }, title),
          subtitle && (
            h(p, {
              className: 'text--grey padding-bottom',
            }, [
              subtitle.partOne || null,
            ])
          ),
          paragraphTwo &&
            h(p, {
              className: 'text--grey padding-bottom',
            }, paragraphTwo),
          sectionOne && sectionOne.listOne &&
            h(p, {
              className: 'text--grey',
            }, sectionOne.listOne),
          sectionOne && sectionOne.listOne &&
            h('ul', {className: 'text--grey'}, [
              h('li', {}, sectionOne.bulletOne),
              sectionOne.bulletTwo &&
              h('li', {}, sectionOne.bulletTwo),
              sectionOne.bulletThree &&
              h('li', {}, sectionOne.bulletThree),
            ]),
          sectionOne && sectionOne.endCopy &&
            h(p, {className: 'text--grey'}, [
              sectionOne.endCopy,
            ]),
        ]),

        h(Image, {
          key: 'Report card hero image',
          src: this.props.image,
          className: 'report-overview__hero-image',
          alt: this.props.alt,
        }, null),
      ])
    );
  }
}

export default Hero;
